'use client'

import { useState } from 'react'
import { useUser } from '@clerk/nextjs'
import { KeyRound } from 'lucide-react'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import { Card, CardHeader } from '@/components/ui/card'
import { ChangePasswordDialog } from '@/features/auth'
import { AdminShell } from '@/features/admin/components/admin-shell'

function initials(name: string | null | undefined): string {
  if (!name) return 'AD'
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('')
}

export function AdminProfileView() {
  const { user } = useUser()
  const [changePasswordOpen, setChangePasswordOpen] = useState(false)
  const name = user?.fullName ?? 'Admin'
  const email = user?.primaryEmailAddress?.emailAddress ?? ''

  return (
    <AdminShell active="profile" title="Profile" description="Your account and preferences.">
      <Card>
        <CardHeader className="flex-row items-center gap-4">
          <Avatar className="size-14">
            <AvatarFallback className="bg-primary text-primary-foreground text-lg font-bold">
              {initials(name)}
            </AvatarFallback>
          </Avatar>
          <div className="min-w-0">
            <p className="text-lg font-semibold">{name}</p>
            <p className="text-muted-foreground text-sm">{email}</p>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="ml-auto shrink-0"
            onClick={() => setChangePasswordOpen(true)}
          >
            <KeyRound className="size-3.5" /> Change Password
          </Button>
        </CardHeader>
      </Card>

      <ChangePasswordDialog open={changePasswordOpen} onOpenChange={setChangePasswordOpen} />
    </AdminShell>
  )
}
